// @flow
export const ADD_SECTION_TO_STUCTURE = 'ADD_SECTION_TO_STUCTURE';
export const REMOVE_SECTION_FROM_STUCTURE = 'REMOVE_SECTION_FROM_STUCTURE';
export const SET_STRUCTUE = 'SET_STRUCTUE';

export function addSectionToStructure(id: number, index?: number) {
  return { type: ADD_SECTION_TO_STUCTURE, id, index };
}

export function removeSectionFromStructure(index: number) {
  return { type: REMOVE_SECTION_FROM_STUCTURE, index };
}

export function setStructure(ids: Array<number>) {
  return { type: SET_STRUCTUE, ids };
}



// WEBPACK FOOTER //
// ./src/actions/structure.js